import { render } from "./DocumentAuditLog.vue?vue&type=template&id=0bc1933e&scoped=true"
import script from "./DocumentAuditLog.vue?vue&type=script&lang=js"
export * from "./DocumentAuditLog.vue?vue&type=script&lang=js"

import "./DocumentAuditLog.vue?vue&type=style&index=0&id=0bc1933e&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\eNotary.SPA\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bc1933e"]])

export default __exports__